module.exports = __webpack_public_path__ + "img/poster.39aa71b9.jpg";